var cov_24lev1pg4x = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/resizable.tsx",
      hash = "0ca14f8c870e395cbe36e6c613777c2953825310",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/resizable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "1": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 18
        }
      },
      "2": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "3": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 36
        }
      },
      "4": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 56
        }
      },
      "5": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 60
        }
      },
      "6": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 26
        }
      },
      "7": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 55,
          column: 7
        }
      },
      "8": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 28
        }
      },
      "9": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 61,
          column: 7
        }
      },
      "10": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 100
        }
      },
      "11": {
        start: {
          line: 60,
          column: 51
        },
        end: {
          line: 60,
          column: 99
        }
      },
      "12": {
        start: {
          line: 65,
          column: 23
        },
        end: {
          line: 65,
          column: 33
        }
      },
      "13": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 38
        }
      },
      "14": {
        start: {
          line: 66,
          column: 22
        },
        end: {
          line: 66,
          column: 38
        }
      },
      "15": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 70,
          column: 7
        }
      },
      "16": {
        start: {
          line: 74,
          column: 14
        },
        end: {
          line: 74,
          column: 25
        }
      },
      "17": {
        start: {
          line: 75,
          column: 14
        },
        end: {
          line: 75,
          column: 25
        }
      },
      "18": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 30
        }
      },
      "19": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 76,
          column: 30
        }
      },
      "20": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 84,
          column: 7
        }
      },
      "21": {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 79,
          column: 22
        }
      },
      "22": {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 22
        }
      },
      "23": {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 57
        }
      },
      "24": {
        start: {
          line: 81,
          column: 46
        },
        end: {
          line: 81,
          column: 57
        }
      },
      "25": {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 57
        }
      },
      "26": {
        start: {
          line: 82,
          column: 46
        },
        end: {
          line: 82,
          column: 57
        }
      },
      "27": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 23
        }
      },
      "28": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 66
        }
      },
      "29": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 62
        }
      },
      "30": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 65
        }
      },
      "31": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 29
        }
      },
      "32": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 69
        }
      },
      "33": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 65
        }
      },
      "34": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 68
        }
      },
      "35": {
        start: {
          line: 102,
          column: 28
        },
        end: {
          line: 102,
          column: 38
        }
      },
      "36": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 45
        }
      },
      "37": {
        start: {
          line: 103,
          column: 39
        },
        end: {
          line: 103,
          column: 45
        }
      },
      "38": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 26
        }
      },
      "39": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 93
        }
      },
      "40": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 106,
          column: 26
        }
      },
      "41": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 26
        }
      },
      "42": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 110,
          column: 7
        }
      },
      "43": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "44": {
        start: {
          line: 112,
          column: 7
        },
        end: {
          line: 120,
          column: 8
        }
      },
      "45": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 70
        }
      },
      "46": {
        start: {
          line: 113,
          column: 64
        },
        end: {
          line: 113,
          column: 70
        }
      },
      "47": {
        start: {
          line: 114,
          column: 24
        },
        end: {
          line: 114,
          column: 53
        }
      },
      "48": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 59
        }
      },
      "49": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 71
        }
      },
      "50": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 53
        }
      },
      "51": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 36
        }
      },
      "52": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 42
        }
      },
      "53": {
        start: {
          line: 124,
          column: 57
        },
        end: {
          line: 124,
          column: 67
        }
      },
      "54": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 55
        }
      },
      "55": {
        start: {
          line: 125,
          column: 22
        },
        end: {
          line: 125,
          column: 55
        }
      },
      "56": {
        start: {
          line: 126,
          column: 17
        },
        end: {
          line: 126,
          column: 58
        }
      },
      "57": {
        start: {
          line: 127,
          column: 17
        },
        end: {
          line: 127,
          column: 77
        }
      },
      "58": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 66
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 16
          },
          end: {
            line: 20,
            column: 17
          }
        },
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        loc: {
          start: {
            line: 37,
            column: 41
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        },
        loc: {
          start: {
            line: 48,
            column: 24
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 25
          },
          end: {
            line: 56,
            column: 5
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        },
        loc: {
          start: {
            line: 58,
            column: 27
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 58
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 60,
            column: 30
          },
          end: {
            line: 60,
            column: 31
          }
        },
        loc: {
          start: {
            line: 60,
            column: 51
          },
          end: {
            line: 60,
            column: 99
          }
        },
        line: 60
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        loc: {
          start: {
            line: 64,
            column: 15
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 64
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        loc: {
          start: {
            line: 73,
            column: 35
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 73
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 78,
            column: 14
          },
          end: {
            line: 78,
            column: 15
          }
        },
        loc: {
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 83,
            column: 9
          }
        },
        line: 78
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        loc: {
          start: {
            line: 87,
            column: 36
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 87
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        loc: {
          start: {
            line: 94,
            column: 20
          },
          end: {
            line: 99,
            column: 5
          }
        },
        line: 94
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        },
        loc: {
          start: {
            line: 101,
            column: 20
          },
          end: {
            line: 121,
            column: 5
          }
        },
        line: 101
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 112,
            column: 32
          },
          end: {
            line: 112,
            column: 33
          }
        },
        loc: {
          start: {
            line: 112,
            column: 39
          },
          end: {
            line: 120,
            column: 7
          }
        },
        line: 112
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 5
          }
        },
        loc: {
          start: {
            line: 123,
            column: 13
          },
          end: {
            line: 129,
            column: 5
          }
        },
        line: 123
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        }, {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        }],
        line: 53
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 38
          }
        }, {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 38
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 30
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 30
          }
        }],
        line: 76
      },
      "4": {
        loc: {
          start: {
            line: 81,
            column: 10
          },
          end: {
            line: 81,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 10
          },
          end: {
            line: 81,
            column: 57
          }
        }, {
          start: {
            line: 81,
            column: 10
          },
          end: {
            line: 81,
            column: 57
          }
        }],
        line: 81
      },
      "5": {
        loc: {
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 57
          }
        }, {
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 57
          }
        }],
        line: 82
      },
      "6": {
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 45
          }
        }, {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 45
          }
        }],
        line: 103
      },
      "7": {
        loc: {
          start: {
            line: 103,
            column: 10
          },
          end: {
            line: 103,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 10
          },
          end: {
            line: 103,
            column: 20
          }
        }, {
          start: {
            line: 103,
            column: 24
          },
          end: {
            line: 103,
            column: 37
          }
        }],
        line: 103
      },
      "8": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 26
          }
        }, {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 26
          }
        }],
        line: 106
      },
      "9": {
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 70
          }
        }, {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 70
          }
        }],
        line: 113
      },
      "10": {
        loc: {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 113,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 113,
            column: 41
          }
        }, {
          start: {
            line: 113,
            column: 45
          },
          end: {
            line: 113,
            column: 62
          }
        }],
        line: 113
      },
      "11": {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 55
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 55
          }
        }],
        line: 125
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/resizable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import { resizableClass } from './styles';
import { getUidStr } from '../utils/uid';
export default (function (Origin) {
  var _temp;

  cov_24lev1pg4x.f[0]++;
  cov_24lev1pg4x.s[0]++;
  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Resizable, _React$Component);

    var _super = _createSuper2(Resizable);

    function Resizable(props) {
      var _this;

      _classCallCheck(this, Resizable);

      cov_24lev1pg4x.f[1]++;
      cov_24lev1pg4x.s[1]++;
      _this = _super.call(this, props);
      _this.resizableId = void 0;
      _this.handlers = void 0;
      _this.active = void 0;
      _this.appended = void 0;
      _this.size = void 0;
      _this.el = void 0;
      cov_24lev1pg4x.s[2]++;
      _this.state = {
        x: 0,
        y: 0
      };
      cov_24lev1pg4x.s[3]++;
      _this.resizableId = getUidStr();
      cov_24lev1pg4x.s[4]++;
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      cov_24lev1pg4x.s[5]++;
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Resizable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_24lev1pg4x.f[2]++;
        cov_24lev1pg4x.s[6]++;
        this.appendHandler();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        cov_24lev1pg4x.f[3]++;
        cov_24lev1pg4x.s[7]++;

        if (this.props.resizable) {
          cov_24lev1pg4x.b[0][0]++;
          cov_24lev1pg4x.s[8]++;
          this.appendHandler();
        } else {
          cov_24lev1pg4x.b[0][1]++;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_24lev1pg4x.f[4]++;
        cov_24lev1pg4x.s[9]++;

        if (this.handlers) {
          cov_24lev1pg4x.b[1][0]++;
          cov_24lev1pg4x.s[10]++;
          this.handlers.forEach(function (action, handler) {
            cov_24lev1pg4x.f[5]++;
            cov_24lev1pg4x.s[11]++;
            return handler.removeEventListener('mousedown', action);
          });
        } else {
          cov_24lev1pg4x.b[1][1]++;
        }
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        cov_24lev1pg4x.f[6]++;

        var _ref = (cov_24lev1pg4x.s[12]++, this.state),
            x = _ref.x,
            y = _ref.y;

        cov_24lev1pg4x.s[13]++;

        if (!this.size) {
          cov_24lev1pg4x.b[2][0]++;
          cov_24lev1pg4x.s[14]++;
          return undefined;
        } else {
          cov_24lev1pg4x.b[2][1]++;
        }

        cov_24lev1pg4x.s[15]++;
        return {
          width: this.size.width + x,
          height: this.size.height + y
        };
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        var _this2 = this;

        cov_24lev1pg4x.f[7]++;
        var x = (cov_24lev1pg4x.s[16]++, e.movementX);
        var y = (cov_24lev1pg4x.s[17]++, e.movementY);
        cov_24lev1pg4x.s[18]++;

        if (!this.active) {
          cov_24lev1pg4x.b[3][0]++;
          cov_24lev1pg4x.s[19]++;
          return;
        } else {
          cov_24lev1pg4x.b[3][1]++;
        }

        cov_24lev1pg4x.s[20]++;
        this.setState(immer(function (draft) {
          cov_24lev1pg4x.f[8]++;
          cov_24lev1pg4x.s[21]++;
          x += draft.x;
          cov_24lev1pg4x.s[22]++;
          y += draft.y;
          cov_24lev1pg4x.s[23]++;

          if (_this2.active.indexOf('x') >= 0) {
            cov_24lev1pg4x.b[4][0]++;
            cov_24lev1pg4x.s[24]++;
            draft.x = x;
          } else {
            cov_24lev1pg4x.b[4][1]++;
          }

          cov_24lev1pg4x.s[25]++;

          if (_this2.active.indexOf('y') >= 0) {
            cov_24lev1pg4x.b[5][0]++;
            cov_24lev1pg4x.s[26]++;
            draft.y = y;
          } else {
            cov_24lev1pg4x.b[5][1]++;
          }
        }));
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(dir) {
        cov_24lev1pg4x.f[9]++;
        cov_24lev1pg4x.s[27]++;
        this.active = dir;
        cov_24lev1pg4x.s[28]++;
        document.addEventListener('mousemove', this.handleMouseMove);
        cov_24lev1pg4x.s[29]++;
        document.addEventListener('mouseup', this.handleMouseUp);
        cov_24lev1pg4x.s[30]++;
        document.addEventListener('mouseleave', this.handleMouseUp);
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        cov_24lev1pg4x.f[10]++;
        cov_24lev1pg4x.s[31]++;
        this.active = undefined;
        cov_24lev1pg4x.s[32]++;
        document.removeEventListener('mousemove', this.handleMouseMove);
        cov_24lev1pg4x.s[33]++;
        document.removeEventListener('mouseup', this.handleMouseUp);
        cov_24lev1pg4x.s[34]++;
        document.removeEventListener('mouseleave', this.handleMouseUp);
      }
    }, {
      key: "appendHandler",
      value: function appendHandler() {
        var _this3 = this;

        cov_24lev1pg4x.f[11]++;

        var _ref2 = (cov_24lev1pg4x.s[35]++, this.props),
            resizable = _ref2.resizable;

        cov_24lev1pg4x.s[36]++;

        if ((cov_24lev1pg4x.b[7][0]++, !resizable) || (cov_24lev1pg4x.b[7][1]++, this.appended)) {
          cov_24lev1pg4x.b[6][0]++;
          cov_24lev1pg4x.s[37]++;
          return;
        } else {
          cov_24lev1pg4x.b[6][1]++;
        }

        cov_24lev1pg4x.s[38]++;
        this.appended = true;
        cov_24lev1pg4x.s[39]++;
        this.el = document.querySelector(".".concat(resizableClass(this.resizableId)));
        cov_24lev1pg4x.s[40]++;

        if (!this.el) {
          cov_24lev1pg4x.b[8][0]++;
          cov_24lev1pg4x.s[41]++;
          return;
        } else {
          cov_24lev1pg4x.b[8][1]++;
        }

        cov_24lev1pg4x.s[42]++;
        this.size = {
          width: this.el.clientWidth,
          height: this.el.clientHeight
        };
        cov_24lev1pg4x.s[43]++;
        this.handlers = new Map();
        cov_24lev1pg4x.s[44]++;
        ['x', 'y', 'xy'].forEach(function (dir) {
          cov_24lev1pg4x.f[12]++;
          cov_24lev1pg4x.s[45]++;

          if ((cov_24lev1pg4x.b[10][0]++, typeof resizable === 'string') && (cov_24lev1pg4x.b[10][1]++, resizable !== dir)) {
            cov_24lev1pg4x.b[9][0]++;
            cov_24lev1pg4x.s[46]++;
            return;
          } else {
            cov_24lev1pg4x.b[9][1]++;
          }

          var handler = (cov_24lev1pg4x.s[47]++, document.createElement('div'));
          var action = (cov_24lev1pg4x.s[48]++, _this3.handleMouseDown.bind(_this3, dir));
          cov_24lev1pg4x.s[49]++;
          handler.className = resizableClass('handler', "handler-".concat(dir));
          cov_24lev1pg4x.s[50]++;
          handler.addEventListener('mousedown', action);
          cov_24lev1pg4x.s[51]++;

          _this3.el.appendChild(handler);

          cov_24lev1pg4x.s[52]++;

          _this3.handlers.set(handler, action);
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_24lev1pg4x.f[13]++;

        var _ref3 = (cov_24lev1pg4x.s[53]++, this.props),
            resizable = _ref3.resizable,
            className = _ref3.className,
            style = _ref3.style,
            others = _objectWithoutProperties(_ref3, ["resizable", "className", "style"]);

        cov_24lev1pg4x.s[54]++;

        if (!resizable) {
          cov_24lev1pg4x.b[11][0]++;
          cov_24lev1pg4x.s[55]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 125,
                columnNumber: 30
              }
            }))
          );
        } else {
          cov_24lev1pg4x.b[11][1]++;
        }

        var ms = (cov_24lev1pg4x.s[56]++, Object.assign({}, style, this.getStyle()));
        var mc = (cov_24lev1pg4x.s[57]++, classnames(className, resizableClass('_', this.resizableId)));
        cov_24lev1pg4x.s[58]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, others, {
            style: ms,
            className: mc,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return Resizable;
  }(React.Component), _temp;
});